import { c as _c } from "react/compiler-runtime";
import { useToasts } from '../components/common/Toast';
const fallbackCopyTextToClipboard = (text: string): Promise<boolean> => {
  return new Promise(resolve => {
    const previous_focus = document.activeElement as HTMLElement | null;
    const text_area = document.createElement('textarea');
    text_area.value = text;
    text_area.style.top = '0';
    text_area.style.left = '0';
    text_area.style.position = 'fixed';
    document.body.appendChild(text_area);
    text_area.focus();
    text_area.select();
    let success;
    try {
      success = document.execCommand('copy');
    } catch (err) {
      success = false;
    } finally {
      // Don't leave the copied text in the page, since it can be a secret.
      text_area.remove();
      previous_focus?.focus();
    }
    resolve(success);
  });
};
export const copyTextToClipboard = async (text: string): Promise<boolean> => {
  // Write directly within the caller's user gesture. Deferring the write (e.g. via
  // setTimeout) drops WebKit's transient activation, so Safari rejects the clipboard
  // write — which previously escaped as an unhandled promise rejection. Always resolve
  // to a boolean and fall back on failure; never reject.
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch (e) {
      // Clipboard API unavailable in this context (e.g. Safari outside a gesture); fall back.
    }
  }
  return fallbackCopyTextToClipboard(text);
};
export const useCopyToClipboard = () => {
  const $ = _c(2);
  const {
    addToast
  } = useToasts();
  let t0;
  if ($[0] !== addToast) {
    t0 = text => {
      copyTextToClipboard(text).then(success => addToast(success ? "success" : "error", success ? "Copied to clipboard" : "Failed to copy to clipboard")).catch(() => addToast("error", "Failed to copy to clipboard"));
    };
    $[0] = addToast;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};